<template>
  <modal-template :title="$t('airbnb.BuscarAlojamiento')"
                  class="airbnb-modal"
                  @close="$emit('closeAirbnb')">
    <div class="container-airbnb-modal">
      <iframe :src="accommodation.url"
              :title="$t('airbnb.BuscarAlojamiento')"
              frameborder="noborder"
              style="width: 100%; height: 100%;" />
    </div>
  </modal-template>

</template>

<script>
import ModalTemplate from '@/components/modal-template/ModalTemplate.vue'

export default {
  components: {
    ModalTemplate
  },
  props: {
    accommodation: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
<style lang="scss">
#wegow-default-styles {
  .airbnb-modal {
    .container-airbnb-modal {
      height: 100vh;
      @media screen and (min-width: $screen-sm) {
        height: calc(100vh - 280px);
      }
    }
  }
}
</style>
